<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.working_hours.title') }}</h3>
    <v-card class="mt-2" elevation="0" >
      <v-flex xs12 lg6>
        <v-simple-table>
          <template v-slot:default>
<!--            <thead>-->
<!--            <tr >-->
<!--              <th class="text-left">-->

<!--              </th>-->
<!--              <th class="text-left">-->

<!--              </th>-->
<!--              <th class="text-left">-->

<!--              </th>-->
<!--            </tr>-->
<!--            </thead>-->
            <tbody>
            <tr
                v-for="day in days"
                :key="day.day_num"
            >
              <td>{{ $t("common."+day.day) }}</td>
              <td>
                <time-picker
                    class="mt-2 d-block mb-3"
                    outlined
                    :time-label="$t('common.start_time')"
                    :time.sync="tmpWorkingHours[day.day+'_start']"
                    :min-time="undefined"
                />
              </td>
              <td>
                <time-picker
                    class="mt-2 d-block mb-3"
                    outlined
                    :time-label="$t('common.end_time')"
                    :time.sync="tmpWorkingHours[day.day+'_end']"
                    :min-time="undefined"
                />
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
        <v-spacer></v-spacer>
        <v-btn
            :disabled="isFetching || savingInProgress"
            :loading="isFetching || savingInProgress"
            class="mt-5 white--text mr-4"
            elevation="0"
            color="red"
            @click="setTmpWorkingHours"
            @keyup.enter="setTmpWorkingHours"
        >
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
            :disabled="isFetching || savingInProgress"
            :loading="isFetching || savingInProgress"
            class="mt-5"
            elevation="0"
            color="primary"
            @click="submit"
            @keyup.enter="submit"
        >
          {{ $t("common.save") }}
        </v-btn>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import CommonMixin from "@/mixins/common";
import {mapState} from "vuex";
import TimePicker from "@/components/common/TimePicker.vue";

export default {
  name: "ShopWorkingHours",
  components: {TimePicker},
  mixins:[CommonMixin],
  data: () => ({
    menu:{
      'monday_start':false,
      'monday_end':false,
    },
    tmpWorkingHours: [],
    days:[
      {"day":"monday", "day_num":1},
      {"day":"tuesday", "day_num":2},
      {"day":"wednesday", "day_num":3},
      {"day":"thursday", "day_num":4},
      {"day":"friday", "day_num":5},
      {"day":"saturday", "day_num":6},
      {"day":"sunday", "day_num":7},
    ]
  }),
  created() {
    this.onLoad();
  },
  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  computed: {
    ...mapState("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    ...mapState("shops", ["savingInProgress"]),

  },
  methods: {
    submit(){
      this.$store.dispatch('shops/updateWorkingHours', this.tmpWorkingHours).then((workingHours)=>{
        this.authenticatedUser.shop.working_hours = workingHours;
      })
    },
    onLoad() {
      this.setTmpWorkingHours();
    },
    setTmpWorkingHours(){
      this.tmpWorkingHours = this.authenticatedUser && this.authenticatedUser.shop && this.authenticatedUser.shop.working_hours;
    }
  }
}
</script>

<style scoped>

</style>